<template>


    <Form @submit="onSubmit" @invalid-submit="onInvalidSubmit" :validation-schema="schema">
        <div class="container">
            <div class="row details-wrapper mt-5">

                <div class="col-xl-12 ">

                    <div class="has-shadow">
                        <div class="bg-white p-5">
                            <div>

                                <div v-if="!isAuthenticated">

                                    <h4 class="mb-4 details-heading">Lead booker details</h4>

                                    <div class="row">
                                        <div class="details-label">Who is the lead booker?</div>
                                        <div class="row mb-5">
                                            <div v-for="guest in guests"
                                                 class="col-xl-12">

                                                <label class="guest-selector">
                                                    <input type="radio"
                                                           v-on:click="guestSelected = true; hasLeadGuest = true;"
                                                           v-model="selectedGuest"
                                                           v-bind:value="guest" />
                                                    {{guest.firstName}} {{guest.lastName}}

                                                </label>

                                            </div>
                                            <div class="col-xl-12">
                                                <label class="guest-selector">
                                                    <input type="radio" v-model="selectedGuest"
                                                           v-on:click="hasLeadGuest = true;"
                                                           v-bind:value="defaultGuest" />
                                                    Someone else
                                                </label>
                                            </div>

                                            <div class="col-24">
                                                <Field v-if="hasLeadGuest" autocomplete="new-password" name="hasLeadGuest" type="hidden" :value="true" />
                                                <Field v-else="hasLeadGuest" autocomplete="new-password" name="hasLeadGuest" type="hidden" :value="false" />

                                                <ErrorMessage name="hasLeadGuest" class="error-message" />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div v-else>
                                    <Field autocomplete="new-password" name="hasLeadGuest" type="hidden" :value="true" />
                                    <h4 class="mb-4 details-heading">Your details</h4>
                                </div>


                                <div class="form-group row ">

                                    <div class="col-12 col-xl-8 mb-4">
                                        <div class="details-label">
                                            Title
                                        </div>
                                        <Field name="title"
                                               autocomplete="new-password"
                                               as="select"
                                               class="form-select"
                                               v-if="!hasSelectedGuest"
                                               v-model="selectedGuest.title">
                                            <option v-for="title in titles" v-bind:key="title.OperaCode" v-bind:value="title.OperaCode">{{title.DisplayName}}</option>
                                        </Field>


                                        <Field name="title"
                                               autocomplete="new-password"
                                               type="text"
                                               class="form-control"
                                               v-if="hasSelectedGuest"
                                               readonly
                                               v-model="selectedGuest.title"></Field>

                                        <ErrorMessage name="title" class="error-message" />

                                    </div>
                                </div>
                                <div class="form-group row ">
                                    <div class="col-xl-12 mb-4">
                                        <div class="details-label">
                                            First Name
                                        </div>

                                        <Field name="firstName"
                                               autocomplete="new-password"
                                               v-bind:readonly="hasSelectedGuest"
                                               class="form-control"
                                               v-model="selectedGuest.firstName"></Field>
                                        <ErrorMessage name="firstName" class="error-message" />


                                    </div>
                                    <div class="col-xl-12 mb-4">
                                        <div class="details-label">
                                            Last Name
                                        </div>
                                        <Field name="lastName"
                                               autocomplete="new-password"
                                               v-bind:readonly="hasSelectedGuest"
                                               class="form-control"
                                               v-model="selectedGuest.lastName"></Field>
                                        <ErrorMessage name="lastName" class="error-message" />

                                    </div>
                                </div>


                                <div class="form-group row mb-4">
                                    <div class="col-24">
                                        <div class="details-label">
                                            Email
                                        </div>
                                        <Field name="email" type="email" class="form-control" v-model="selectedGuest.email"
                                               autocomplete="new-password"></Field>
                                        <ErrorMessage name="email" class="error-message" />


                                    </div>
                                </div>

                                <div class="form-group row mb-4">
                                    <div class="col-24">
                                        <div class="details-label">
                                            Telephone
                                        </div>

                                        <Field autocomplete="new-password" name="telephone" class="form-control" placeholder="+44" v-model="selectedGuest.telephone"></Field>
                                        <ErrorMessage name="telephone" class="error-message" />


                                    </div>
                                </div>


                                <div class="form-group row mb-4">
                                    <div class="col-24">
                                        <div class="details-label">
                                            Address
                                        </div>

                                        <Field autocomplete="new-password" name="address.country" as="select" class="form-select" v-model="selectedCountry">
                                            <option v-for="country in countries" v-bind:key="country.OperaCode" v-bind:value="country.OperaCode">{{country.DisplayName}}</option>
                                        </Field>
                                        <ErrorMessage name="address.country" class="error-message" />

                                    </div>
                                </div>
                                <Field autocomplete="new-password" name="address.isManualEntry" type="hidden" v-model="manualAddressEntry"></Field>

                                <div v-if="selectedCountry == 'GB' && !manualAddressEntry">

                                    <div class="form-group row mb-4 flex-row g-0">

                                        <div class="col-xl-12  mb-4 mb-xl-0">
                                            <input type="text" class="form-control  " placeholder="Enter postcode" v-model="searchPostcode" />


                                        </div>
                                        <div class="col-xl-12">
                                            <button class="btn btn--gold" type="button" v-on:click="onLookupAddress">Find Address</button>
                                        </div>
                                    </div>

                                    <div v-if="addressList ">

                                        <div class="form-group row mb-4">
                                            <div class="col">


                                                <select class="form-select" v-on:change="onSelectAddress" v-model="selectedAddress">
                                                    <option disabled selected v-bind:value="null">Please select...</option>
                                                    <option v-bind:value="address" v-for="address in addressList">
                                                        {{address.line1}} {{address.locality}}
                                                    </option>
                                                </select>


                                            </div>
                                        </div>
                                    </div>


                                    <div class="form-group row " v-if="!manualAddressEntry && selectedAddress== null">

                                        <div class="col-24 ">
                                            <button type="button" class="btn btn--manual-address " v-on:click="manualAddressEntry = true">
                                                Manually Enter Address
                                            </button>
                                        </div>
                                    </div>
                                    <div class="mb-4">
                                        <Field autocomplete="new-password" name="address.selectedAddress" type="hidden" v-model="localAddress.postCode"></Field>

                                        <ErrorMessage name="address.selectedAddress" class="error-message" />
                                    </div>
                                </div>

                            
                                <div v-show="manualAddressEntry || selectedCountry != 'GB' || selectedAddress != null">

                                    <div class="form-group row mb-4">
                                        <div class="col-24">
                                            <div class="details-label">
                                                First line of address
                                            </div>

                                            <Field autocomplete="new-password" name="address.line1" class="form-control" v-model="localAddress.line1"></Field>
                                            <ErrorMessage name="address.line1" class="error-message" />

                                        </div>
                                    </div>


                                    <div class="form-group row mb-4">
                                        <div class="col-24">
                                            <div class="details-label">
                                                Second line of address (optional)
                                            </div>

                                            <Field autocomplete="new-password" name="address.line2" class="form-control" v-model="localAddress.line2"></Field>
                                            <ErrorMessage name="address.line2" class="error-message" />

                                        </div>
                                    </div>

                                    <div class="form-group row mb-4">
                                        <div class="col-xl-18">
                                            <div class="details-label">
                                                City
                                            </div>
                                            <Field autocomplete="new-password" name="address.city" class="form-control" v-model="localAddress.city"></Field>
                                            <ErrorMessage name="address.city" class="error-message" />

                                        </div>
                                    </div>


                                    <div class="form-group row mb-4">
                                        <div class="col-xl-12">
                                            <div class="details-label">
                                                Postcode
                                            </div>
                                            <Field autocomplete="new-password" name="address.postCode" class="form-control" v-model="localAddress.postCode"></Field>
                                            <ErrorMessage name="address.postCode" class="error-message" />

                                        </div>
                                    </div>
                                </div>















                                <h4 class="mb-4 details-heading">Just a few last questions</h4>


                                <div v-if="booking.legs.length > 1" class="btn-container">
                                    <div class="row w-100 ">
                                        <div class="col-xl-12 g-0 p-1 mb-1 mb-xl-0"
                                             v-for="(leg, index) in booking.legs"
                                             v-bind:key="leg.leg">
                                            <button class="btn btn--slate-blue btn--toggle btn--block"
                                                    v-bind:class="{'btn--toggle-active' : index == activeRequestsIndex, 'leg-requests-invalid' : leg.dogValid != undefined &&  !leg.dogValid}"
                                                    type="button"
                                                    v-on:click="activeRequestsIndex = index">


                                                {{getLegNames(leg.leg, true)}}
                                            </button>
                                        </div>
                                    </div>


                                </div>
                                <div v-for="(leg, index) in booking.legs"
                                     v-bind:key="leg.leg">
                                    <div v-show="activeRequestsIndex == index">

                                        <Field autocomplete="new-password" :name="`requests[${index}].leg`" type="hidden" :value="leg.leg" />
                                        <Field autocomplete="new-password" :name="`requests[${index}].hasDog`" type="hidden" :value="leg.guestQuota.Dogs > 0" />

                                        <div class="form-group row mb-4" v-if="leg.guestQuota.Dogs > 0">
                                            <div class="col-24">
                                                <div class="details-label">
                                                    Dog Information
                                                </div>

                                                <Field autocomplete="new-password"
                                                       v-bind:name="`requests[${index}].dogRequests`"
                                                       v-bind:placeholder="dogPlaceHolder(leg)"
                                                       class="form-control"
                                                       as="textarea" />
                                                <ErrorMessage v-bind:name="`requests[${index}].dogRequests`" class="error-message" />


                                            </div>
                                        </div>


                                        <div class="form-group row mb-4">
                                            <div class="col-24">
                                                <div class="details-label">
                                                    Dietary Requirements
                                                </div>

                                                <Field autocomplete="new-password"
                                                       v-bind:name="`requests[${index}].dietaryRequirements`"
                                                       v-bind:placeholder="dietaryPlaceHolder(leg)"
                                                       class="form-control"
                                                       as="textarea"
                                                       rows="3" />
                                                <ErrorMessage v-bind:name="`requests[${index}].dietaryRequirements`" class="error-message" />


                                            </div>
                                        </div>

                                        <div class="form-group row mb-4">
                                            <div class="col-24">
                                                <div class="details-label">
                                                    Special Requirements
                                                </div>

                                                <Field autocomplete="new-password"
                                                       v-bind:name="`requests[${index}].specialRequests`"
                                                       v-bind:placeholder="specialRequirementsPlaceHolder(leg)"
                                                       class="form-control"
                                                       as="textarea"
                                                       rows="3" />
                                                <ErrorMessage v-bind:name="`requests[${index}].specialRequests`" class="error-message" />

                                            </div>
                                        </div>
                                        <div class="form-group row mb-4">
                                            <div class="col-24">
                                                <div class="details-label">
                                                    Dinner Booking Requests
                                                </div>

                                                <Field autocomplete="new-password"
                                                       v-bind:name="`requests[${index}].dinnerRequests`"
                                                       v-bind:placeholder="dinnerRequestsPlaceHolder(leg)"
                                                       class="form-control"
                                                       as="textarea"
                                                       rows="3" />
                                                <ErrorMessage v-bind:name="`requests[${index}].dinnerRequests`" class="error-message" />



                                            </div>
                                        </div>
                                    </div>


                                </div>


                                <div class="row form-group">
                                    <div class="col-24">
                                        <label class="terms-label">
                                            <Field autocomplete="new-password" name="terms" type="checkbox" value="true"></Field>
                                            I agree to the <a href="/privacy-cookie-policy/" target="_blank">privacy notice</a> and <a href="/general-booking-terms/" target="_blank">terms of use</a>
                                        </label>
                                        <ErrorMessage name="terms" class="error-message" />

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-slate-blue p-5 account-panel" v-if="!isAuthenticated && !isSomeoneElseBooking">

                            <h4 class="details-heading mb-4">Create an account for all these benefits:</h4>
                            <ul>
                                <li>View all your bookings in one place</li>
                                <li>Easily amend your booking</li>
                                <li>Upgrade your stay</li>
                            </ul>

                            <p>Just enter a password and we'll create an account for you (optional)</p>

                            <div class="row form-group mb-2">
                                <div class="col-24 ">

                                    <Field autocomplete="new-password" name="account.password1" type="password" class="form-control" placeholder="Choose a password"></Field>
                                    <ErrorMessage name="account.password1" class="error-message" />


                                </div>
                            </div>

                            <div class="row form-group mb-4">
                                <div class="col-24 ">

                                    <Field autocomplete="new-password" name="account.password2" type="password" class="form-control" placeholder="Re-enter password"></Field>
                                    <ErrorMessage name="account.password2" class="error-message" />
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-24">
                                    <label class="terms-label">
                                        <input autocomplete="new-password" type="checkbox" v-on:click="toggleMarketing()" />

                                        Join the mailing list (optional)
                                    </label>
                                </div>
                            </div>

                            <div class="row form-group mt-3 mb-3" v-if="showMarketingBoxes">
                                <div class="col-xl-8">
                                    <label class="terms-label">

                                        <Field name="account.addressBooks" type="checkbox" value="3507983"></Field>
                                        Spa
                                    </label>
                                </div>

                                <div class="col-xl-8">
                                    <label class="terms-label">
                                        <Field name="account.addressBooks" type="checkbox" value="3508013"></Field>
                                        Golf
                                    </label>
                                </div>

                                <div class="col-xl-8">
                                    <label class="terms-label">
                                        <Field name="account.addressBooks" type="checkbox" value="3508001"></Field>
                                        Dining
                                    </label>
                                </div>

                                <div class="col-xl-8">
                                    <label class="terms-label">
                                        <Field name="account.addressBooks" type="checkbox" value="3508068"></Field>
                                        Events
                                    </label>
                                </div>

                                <div class="col-xl-8">
                                    <label class="terms-label">
                                        <Field name="account.addressBooks" type="checkbox" value="3507997"></Field>
                                        Rooms
                                    </label>
                                </div>

                                <div class="col-xl-8">
                                    <label class="terms-label">
                                        <Field name="addressBooks" type="checkbox" value="21980355"></Field>
                                        Offers
                                    </label>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>


            </div>

        </div>
        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-12">

                        <button v-on:click="onBack"
                                type="button"
                                class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>
                    <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn--slate-blue btn--continue"
                                type="submit">
                            Check your booking
                        </button>
                    </div>
                </div>
            </template>
        </actions-bar>
    </Form>

</template>
<script>
    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";
    import "yup-phone";
    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import { store } from '../store/index';
    import { accountStore } from '@/account/store/index';
    import addressapi from '@/shared/api/address';



    export default {
        name: 'StayDetails',

        components: {
            ActionsBar,
            Field,
            Form,
            ErrorMessage
        },
        mounted() {

            if (this.isAuthenticated && this.userProfile != null) {
                this.selectedGuest = {
                    title: this.userProfile.Title,
                    firstName: this.userProfile.FirstName,
                    lastName: this.userProfile.LastName,
                    email: this.userProfile.EmailAddress,
                    telephone: this.userProfile.Telephone,
                };

                if (this.userProfile.Address != undefined && this.userProfile.Address != null) {
                    this.localAddress = {
                        line1: this.userProfile.Address.Line1,
                        line2: this.userProfile.Address.Line2,
                        city: this.userProfile.Address.City,
                        country: this.userProfile.Address.Country,
                        postCode: this.userProfile.Address.PostCode
                    };

                    this.manualAddressEntry = true;
                }
            }
        },
        data() {

            const schema = yup.object().shape({
                hasLeadGuest: yup.string().nullable().required().test('guest-selected', 'Lead guest is a required field', function (value) {

                    if (value != null && value.length) {
                        return value === 'true';
                    }
                    return false;
                }),
                title: yup.string().required().label("Title"),
                firstName: yup.string().required().label("First name"),
                lastName: yup.string().required().label("Last name"),
                email: yup.string().required().email().label("Email address"),
                telephone: yup.string().nullable().required().phone().label("Telephone"),

                address: yup.object().shape({
                    selectedAddress: yup.string().when("isManualEntry", {
                        is: false,
                        then: yup.string().required("Please select an address.")
                    }),
                    isManualEntry: yup.boolean(),
                    line1: yup.string().required().label("Address line 1"),
                    line2: yup.string().notRequired().nullable().label("Address line 2"),
                    city: yup.string().required().label("City"),
                    country: yup.string().required().label("Country"),
                    postCode: yup.string().required().label("Postcode")
                }),
                terms: yup.boolean().required().label("Privacy notice and terms and conditions"),
                account: yup.object().shape({
                    password1: yup.string().notRequired().nullable().label("Password"),
                    password2: yup.string().notRequired().nullable().test('passwords-match', 'Passwords must match', function (value) {
                        if (this.parent.password1 != null && this.parent.password1.length) {
                            return this.parent.password1 === value;
                        }
                        return true;
                    }),
                    addressBooks: yup.array().of(yup.string())
                }),
                requests: yup.array().of(
                    yup.object().shape({
                        hasDog: yup.boolean(),
                        dietaryRequirements: yup.string().notRequired("Dietary requirements"),
                        specialRequests: yup.string().notRequired().label("Special requests"),
                        dinnerRequests: yup.string().notRequired().label("Dinner requests"),
                        dogRequests: yup.string().when("hasDog", {
                            is: true,
                            then: yup.string().required("Please enter your dog information.")
                        })
                    })
                )
            });

            return {
                schema,
                selectedCountry: 'GB',
                defaultGuest: { title: '', firstName: '', lastName: '' },
                activeRequestsIndex: 0,
                selectedGuest: {},
                guestSelected: false,
                manualAddressEntry: false,
                addressList: null,
                searchPostcode: null,
                selectedAddress: null,
                hasLeadGuest: false,
                localAddress: {
                    line1: '',
                    line2: '',
                    city: '',
                    country: '',
                    postCode: ''
                },

                showMarketingBoxes: false
                //acceptedTerms: false,


            }
        },

        computed: {
            userProfile() {
                return accountStore.getters.userProfile;
            },
            hasSelectedGuest() {
                return this.guestSelected && (this.selectedGuest != this.defaultGuest);
            },
            isAuthenticated() {
                return accountStore.getters.isAuthenticated;
            },
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            titles() {
                return store.getters.roomConfiguration.AdultTitles;
            },
            countries() {
                return store.getters.roomConfiguration.Countries;
            },
            content() {
                return store.getters.roomConfiguration.Content;
            },
            isSomeoneElseBooking() {
                return this.defaultGuest == this.selectedGuest;
            },
            guests() {
                var booking = store.getters.booking;

                var result = [];
                for (var li in booking.legs) {
                    var leg = booking.legs[li];
                    for (var gi in leg.guests) {
                        var guest = leg.guests[gi];

                        if (!guest.isChild) {
                            result.push({ leg: leg.leg, legIndex: li, guestIndex: gi, title: guest.title, firstName: guest.firstName, lastName: guest.lastName });
                        }
                    }
                }


                return result;
            },
            bookerIsStaying() {
                var booking = store.getters.booking;


                for (var li in booking.legs) {
                    var leg = booking.legs[li];
                    for (var gi in leg.guests) {
                        var guest = leg.guests[gi];
                        if (guest.isLoggedInUser) {
                            return guest.isLoggedInUser;
                        }
                    }
                }
            }
        },
        methods: {
            toggleMarketing() {
                this.showMarketingBoxes = !this.showMarketingBoxes;
            },

            getLegNames: function (leg, hasAnd) {
                var booking = store.getters.booking;
                var leg = booking.legs.find(item => item.leg == leg);
                var names = '';
                for (var i = 0; i < leg.guests.length; i++) {
                    let guest = leg.guests[i];
                    names += guest.firstName;

                    if (leg.guests.length - 2 == i) {
                        names += hasAnd ? ' & ' : ' or ';
                    }
                    else if (leg.guests.length > i + 1) {
                        names += ', ';
                    }
                }
                return names.trim();
            },
            onSelectAddress: function () {

                if (this.selectedAddress != null) {

                    this.localAddress.line1 = this.selectedAddress.line1;
                    this.localAddress.line2 = this.selectedAddress.locality;
                    this.localAddress.city = this.selectedAddress.city;
                    this.localAddress.postCode = this.searchPostcode.toUpperCase();
                }
                this.addressList = null;
            },
            onLookupAddress: function () {
                var payload = {
                    postalCode: this.searchPostcode
                };

                addressapi.lookupAddress(payload, t => {
                    this.addressList = t.addresses;
                });
            },

            onBack: function () {
                this.$router.push({ name: 'stay_addons', params: { id: this.session.Id } });
            },
            onInvalidSubmit({ values, errors, results }) {

                for (let i = 0; i < this.booking.legs.length; i++) {
                    let leg = this.booking.legs[i];

                    if (leg.guestQuota.Dogs > 0) {

                        leg.dogValid = results["requests[" + i + "].dogRequests"].valid;
                    }
                };

            },

            onSubmit: function (values) {


                this.trackBeginCheckout();

                let thisSelectedGuest = null;
                if (!this.isAuthenticated && this.selectedGuest != this.defaultGuest) {
                    thisSelectedGuest = {
                        legIndex: this.selectedGuest.legIndex,
                        guestIndex: this.selectedGuest.guestIndex
                    }
                }
                var payload = {
                    selectedGuest: thisSelectedGuest,
                    leadGuest: {
                        title: values.title,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        emailAddress: values.email,
                        telephone: values.telephone,
                        address: values.address,
                    },
                    requests: values.requests,
                    account: values.account
                };






                store.dispatch("attachDetails", payload).then(() => {
                    //register account and login...
                    if (payload.account != undefined && payload.account.password1 !== undefined && payload.account.password1.length) {
                        var accountRegistrationPayload = {
                            title: payload.leadGuest.title,
                            firstName: payload.leadGuest.firstName,
                            lastName: payload.leadGuest.lastName,
                            emailAddress: payload.leadGuest.emailAddress,
                            telephone: payload.leadGuest.telephone,
                            address: payload.leadGuest.address,
                            password: payload.account.password1,
                            addressBooks: this.showMarketingBoxes ? values.account.addressBooks : null
                        };

                        accountStore.dispatch("register", accountRegistrationPayload).then((t) => {
                            var loginPayload = {
                                username: accountRegistrationPayload.emailAddress,
                                password: accountRegistrationPayload.password
                            }
                            accountStore.dispatch("login", loginPayload).then(() => {
                                accountStore.dispatch("loadSession").then(() => {
                                    store.dispatch("setAccountStatus", { attempted: true, failed: false })
                                    this.$router.push({ name: 'stay_summary', params: { id: this.session.Id } });
                                });
                            });




                        }).catch((t) => {
                            store.dispatch("setAccountStatus", { attempted: true, failed: true })
                            this.$router.push({ name: 'stay_summary', params: { id: this.session.Id } });



                        });


                    }

                    else {
                        store.dispatch("setAccountStatus", { attempted: false, failed: false })
                        this.$router.push({ name: 'stay_summary', params: { id: this.session.Id } });
                    }


                });

            },
            dietaryPlaceHolder: function (leg) {

                return 'Tell us if ' + this.getLegNames(leg.leg, false) + (this.getTotalGuests(leg) > 1 ? ' have ' : ' has ') + 'any dietary requirements.';
            },
            specialRequirementsPlaceHolder: function (leg) {
                return 'Tell us if ' + this.getLegNames(leg.leg, false) + (this.getTotalGuests(leg) > 1 ? ' have ' : ' has ') + 'have any special booking requests e.g. a cot in the room, hypoallergenic pillows or if they are celebrating a special occasion during their stay.';

            },
            dinnerRequestsPlaceHolder: function (leg) {
                return 'Please advise if you’d like to join with any other tables for breakfast or dinner, including preferred dates if your booking is for more than one night.';

            },
            dogPlaceHolder: function (leg) {
                return 'Tell us the name and breed of your ' + (this.getTotalDogs(leg) > 1 ? 'dogs.' : 'dog.');
            },
            getTotalGuests(leg) {
                return leg.guests.length;
            },
            getTotalDogs(leg) {
                return leg.guestQuota.Dogs;
            },
            trackBeginCheckout() {

                if (this.$gtm.enabled()) {


                    let items = [];
                    let total = 0;
                    for (let li in this.booking.legs) {

                        let leg = this.booking.legs[li];
                        items.push({
                            "item_id": leg.room.PMSCode + '-' + leg.rate.availableRate.RateCode,
                            "item_name": leg.room.DisplayName + ' - ' + leg.rate.availableRate.RateCode,
                            "item_brand": "Rockliffe Hall",
                            "quantity": 1,
                            "price": leg.rate.availableRate.Amount,
                            "item_category": "Room/Rate"
                        })



                        if (leg.includedPackages !== undefined && leg.includedPackages != null && leg.includedPackages.length) {
                            for (let pi = 0; pi < leg.includedPackages.length; pi++) {
                                let pkge = leg.includedPackages[pi];

                                items.push({
                                    "item_id": pkge.Code,
                                    "item_name": pkge.Code,
                                    "item_brand": "Rockliffe Hall",
                                    "quantity": +(pkge.QuantityRequired),
                                    "price": +(pkge.UnitPrice),
                                    "item_category": "Included Package"
                                })
                                total += +(pkge.UnitPrice) * +(pkge.QuantityRequired);
                            }


                        }


                        if (leg.packages !== undefined && leg.packages != null && leg.packages.length) {
                            for (let pIndex = 0; pIndex < leg.packages.length; pIndex++) {
                                let pkge2 = leg.packages[pIndex];

                                items.push({
                                    "item_id": pkge2.item.availability.Code,
                                    "item_name": pkge2.item.content.DisplayName,
                                    "item_brand": "Rockliffe Hall",
                                    "quantity": +(pkge2.quantity),
                                    "price": +(pkge2.item.availability.Amount),
                                    "item_category": "Package"
                                })
                                total += +(pkge2.item.availability.Amount) * +(pkge2.quantity);
                            }


                        }



                        total += +(leg.rate.availableRate.Amount);
                    };


                    window.dataLayer?.push({
                        'pageURL': '/stay/stay/details',
                        'event': 'begin_checkout',
                        'value': total,
                        'curency': 'GBP',
                        'ecommerce': {
                            'items': items
                        }
                    });


                }

            }

        },
        watch: {
            // whenever question changes, this function will run
            selectedCountry(newValue, oldValue) {
                if (newValue == 'GB') {
                    this.manualAddressEntry = false;
                } else{
                    if (!this.manualAddressEntry) {
                        this.manualAddressEntry = true;
                    }
                }

            }
        },

    }
</script>

<style src="@/shared/css/details.css"></style>
<style>

    .leg-requests-invalid {
        background-color: rgb(161, 0, 0);
    }


        .leg-requests-invalid.btn--toggle-active {
            color: rgb(161, 0, 0);
            border-color: rgb(161, 0, 0);
            background: #fff;
        }
</style>
